<template>
  <card class="help-center">
    <main>
      <div class="help-center__title">
        <span>List of questions</span>
        <router-link :to="{ path: 'create' }" class="btn btn-primary"
          >Create</router-link
        >
      </div>
      <el-table :data="categoriesList">
        <el-table-column
          fixed
          v-for="item in titleLanguages"
          :prop="`title[${item.language}]`"
          :label="`Title ${item.language.toUpperCase()}`"
          :key="item.language"
        />
        <el-table-column fixed="right" width="100">
          <template slot-scope="scope">
            <button class="btn btn-primary btn-link"
                @click="handleEdit(scope.row.id)">
                <i class="tim-icons icon-pencil"></i>
              </button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="200">
          <template slot-scope="scope">
            <button
              class="btn btn-danger"
              @click="handleDelete(scope.row.id)"
              >Delete</button
            >
          </template>
        </el-table-column>
      </el-table>
    </main>
  </card>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("helpCenterCategories", ["categoriesList"]),
    ...mapState("cmsApiCatalogs", ["domains"]),

    titleLanguages() {
      return this.domains.filter(
        domain => domain.language === "ru" || domain.language === "en"
      );
    }
  },
  methods: {
    ...mapActions("helpCenterCategories", [
      "getCategoriesList",
      "deleteCategory"
    ]),
    ...mapActions("cmsApiCatalogs", ["getDomains"]),
    getCategoriesListEvent() {
      this.$store.dispatch("setLoader", true);
      return this.getCategoriesList({
        page: this.$route.query.page
      }).finally(() => this.$store.dispatch("setLoader", false));
    },
    handleEdit(id) {
      this.$router.push({ name: "category-edit", params: { id } });
    },
    async handleDelete(id) {
      this.$store.dispatch("setLoader", true);
      try {
        await this.deleteCategory(id);
        await this.getCategoriesListEvent();
        this.$notify({ type: "success", title: "Category deleted" });
      } catch (e) {
        this.$notify({ type: "warning", title: "Error" });
      } finally {
        this.$store.dispatch("setLoader", false);
      }
    }
  },
  created() {
    this.getCategoriesListEvent();
    this.getDomains();
  }
};
</script>
